import { render } from "./ybpj.vue?vue&type=template&id=306942a0&scoped=true&ts=true"
import script from "./ybpj.vue?vue&type=script&lang=ts"
export * from "./ybpj.vue?vue&type=script&lang=ts"

import "./ybpj.vue?vue&type=style&index=0&id=306942a0&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306942a0"]])

export default __exports__